// extracted by mini-css-extract-plugin
export default {"controls":"PlayerCondensedControls_controls__02x+p","controls__visible":"PlayerCondensedControls_controls__visible__zunBc"};